import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";

type Props = {
    size: string;
    show: boolean;
    onHide: () => void;
    children?: ReactNode;
    [any: string]: unknown;
};

export const ModalCentered: React.FunctionComponent<Props> = props => {
    return (
        <Modal {...props} dialogClassName="custom-dialog-size" size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            {props.children}
        </Modal>
    );
};
